import { EntityDeletionState, Rate, RateResult, useRepositoryQuery } from '@mews-commander/data-access';
import { createWeakMapSelector } from '@mews/framework';
import { keyBy } from '@mews/fp';
import { useCurrentEnterpriseId } from '../session';

const getRateById = createWeakMapSelector((rates: Rate[]): Record<string, Rate> => keyBy('id', rates));
export const getQueryRateById = (data: RateResult) => (data.rates ? getRateById(data.rates) : {});

export const useEnterpriseRatesQuery = <T = RateResult>(select?: (data: RateResult) => T) => {
    const currentEnterpriseId = useCurrentEnterpriseId();

    return useRepositoryQuery(
        'rates',
        'getAll',
        {
            enterpriseIds: [currentEnterpriseId],
            serviceDeletionState: EntityDeletionState.Everything,
        },
        {
            select,
            staleTime: 1000 * 60 * 60,
            gcTime: Infinity,
        }
    );
};
export const useEnterpriseRatesByIdQuery = () => useEnterpriseRatesQuery(getQueryRateById);
